import { cloneProviderClient, unwrap } from './cloneProviderClient';

export async function listConfig() {
  const response = await cloneProviderClient.get('/admin/config');
  return unwrap(response);
}

export async function setConfig(key, value) {
  const response = await cloneProviderClient.post(`/admin/config/${encodeURIComponent(key)}`, null, {
    params: { value },
  });
  return unwrap(response);
}

export async function rebalanceServiceGroups() {
  const response = await cloneProviderClient.post('/admin/purchases/rebalance-service-groups');
  return unwrap(response);
}

const configService = { listConfig, setConfig, rebalanceServiceGroups };
export default configService;
